import React from "react";
import SvgProgressIcon from "./SvgProgressIcon"; // Certifique-se de ajustar o caminho

function ProgressCards() {
  const cards = [
    {
      title: "Análise Estratégica de Projetos",
      description:
        "Avaliamos oportunidades no mercado imobiliário com base em viabilidade financeira e potencial de retorno.",
      progress: 20,
    },
    {
      title: "Consultoria Personalizada",
      description:
        "Oferecemos recomendações baseadas nas metas e perfil contratados com cada investidor.",
      progress: 40,
    },
    {
      title: "Intermediação Jurídica",
      description:
        "Garantimos a segurança do processo com contratos elaborados por advogados especializados em todas as fases do projeto.",
      progress: 60,
    },
    {
      title: "Acompanhamento e Gestão",
      description:
        "Acompanhamos de perto todas as etapas do projeto, desde a seleção até a venda, assegurando que cada fase siga com qualidade e dentro das premissas contratuais.",
      progress: 80,
    },
    {
      title: "Entrega de Resultados",
      description:
        "Distribuição dos lucros e reinvestimento, caso deseje continuar expandindo seu patrimônio.",
      progress: 99.999999,
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        flexWrap: "wrap",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      {cards.map((card, index) => (
        <div
          key={index}
          style={{
            width: "300px",
            border: "1px solid #000",
            borderRadius: "15px",
            padding: "20px",
            textAlign: "center",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div style={{ marginBottom: "15px" }}>
            <SvgProgressIcon progress={card.progress} />
          </div>
          <h5
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            {card.title}
          </h5>
          <p
            className="mt-5"
            style={{ fontSize: "14px", color: "#111", letterSpacing: "1.8px" }}
          >
            {card.description}
          </p>
        </div>
      ))}
    </div>
  );
}

export default ProgressCards;
